import Layout from "./src/components/Layout";
import { useStaticQueryDataChatMutuo } from "./src/query/useStaticQueryDataChatMutuo";
import "./src/sass/main.scss";
import {
  CHAT_MUTUO_HIDE_OLD_QUESTIONS,
  CHAT_MUTUO_IS_ACTIVE_LAST_CMS_MESSAGE,
  CHAT_MUTUO_IS_WIZARD_VISIBLE,
  CHAT_MUTUO_LATEST_CMS_MESSAGE,
  CHAT_MUTUO_SHOW_CURRENT_QUESTIONS,
} from "./src/state/actions/chatmutuo.actions";
import {
  CHAT_MUTUO_SET_MESSAGES_CLIENT_ID,
  CHAT_MUTUO_SET_MESSAGES_UID,
  CHAT_MUTUO_IS_LAST_LINK_MESSAGES_VISIBILE, // CHAT_MUTUO_ADD_LAST_LINK_MESSAGES,
} from "./src/state/actions/chatmutuo.actions";
import {
  CONFIG_ADD_GCLID,
  CONFIG_ADD_MSMLID,
  CONFIG_ADD_QUERY_STRING_VALUES,
  CONFIG_ADD_UTMCHATBOT,
  CONFIG_ADD_LAST_METHOD_LID,
  CONFIG_ADD_UTMSOURCE,
  CONFIG_ADD_UTMCAMPAIGN,
  CONFIG_ADD_UTMMEDIUM,
  CONFIG_ADD_MSCLKID,
} from "./src/state/actions/config.actions";
import { getChatMutuo } from "./src/state/selectors/chatmutuo.selector";
import store from "./src/state/store";
import { CHAT_MUTUO_FETCH_HISTORY } from "./src/state/thunk/chatmutuo.thunk";
import { FETCH_HISTORY } from "./src/state/thunk/history.thunk";
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { useSelector } from "react-redux";
import "swiper/css";
import "swiper/css/navigation";
import Cookies from "universal-cookie";

async function initialSetupConfigAppAsync() {
  if (typeof window !== "undefined") {
    const cookie = new Cookies();
    const cookies = cookie.get("user-mutui-history");
    if (cookies) {
      cookies.forEach((element) => {
        store.dispatch(FETCH_HISTORY(element));
      });
    }
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid") || cookie.get("gclid");
    let msmlid = params.get("msmlid") || cookie.get("msmlid");
    let utmsource = params.get("utm_source") || cookie.get("utm_source");
    let utmCampaign = params.get("utm_campaign") || cookie.get("utm_campaign");
    let utmchatbot = params.get("utm_chatbot") || cookie.get("utm_chatbot");
    let utmMedium = params.get("utm_medium") || cookie.get("utm_medium");
    let lastMethodLid = cookie.get("lastMethodLid");
    let msclkid = params.get("msclkid") || cookie.get("msclkid");

    if (params.get("utm_source")) {
      lastMethodLid = "utm_source";
    } else if (params.get("msmlid")) {
      lastMethodLid = "msmlid";
    }

    if (gclid) {
      store.dispatch(CONFIG_ADD_GCLID(gclid.trim()));
      cookie.set("gclid", gclid.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (msmlid) {
      store.dispatch(CONFIG_ADD_MSMLID(msmlid.trim()));
      cookie.set("msmlid", msmlid.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (utmchatbot) {
      store.dispatch(CONFIG_ADD_UTMCHATBOT(utmchatbot.trim()));
      cookie.set("utm_chatbot", utmchatbot.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (utmsource) {
      store.dispatch(CONFIG_ADD_UTMSOURCE(utmsource.trim()));
      cookie.set("utm_source", utmsource.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (lastMethodLid) {
      cookie.set("lastMethodLid", lastMethodLid, {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      }); //1 giorno
      store.dispatch(CONFIG_ADD_LAST_METHOD_LID(lastMethodLid));
    }

    if (utmCampaign) {
      store.dispatch(CONFIG_ADD_UTMCAMPAIGN(utmCampaign.trim()));
      cookie.set("utm_campaign", utmCampaign.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (utmMedium) {
      store.dispatch(CONFIG_ADD_UTMMEDIUM(utmMedium.trim()));
      cookie.set("utm_medium", utmMedium.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (msclkid) {
      store.dispatch(CONFIG_ADD_MSCLKID(msclkid.trim()));
      cookie.set("msclkid", msclkid.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (params?.size > 0) {
      const queryStringValues = {};
      for (const [key, value] of params.entries()) {
        queryStringValues[key] = value;
      }
      if (queryStringValues) {
        store.dispatch(CONFIG_ADD_QUERY_STRING_VALUES(queryStringValues));
      }
    }
    let gaClientID = cookie.get("_ga");
    if (gaClientID) {
      gaClientID = gaClientID.slice(6);
      store.dispatch(CHAT_MUTUO_SET_MESSAGES_CLIENT_ID(gaClientID));
    }
    const chatUID = cookie.get("chatmutuo-uid");
    if (chatUID) {
      store.dispatch(CHAT_MUTUO_SET_MESSAGES_UID(chatUID));
    }
    if (chatUID || gaClientID) {
      store.dispatch(
        CHAT_MUTUO_FETCH_HISTORY({
          uid: chatUID,
          clientId: gaClientID,
        })
      );
    }
  }
}

export const onClientEntry = () => {
  initialSetupConfigAppAsync();
};

function InitialSetupConfigApp({ children }) {
  const {
    chatMutuo: {
      wizard: { abilita },
    },
  } = useStaticQueryDataChatMutuo();

  const {
    messages: { data },
  } = useSelector(getChatMutuo);
  // console.log("INITIAL SETUP data:")
  // console.log(data)

  useEffect(() => {
    // initialSetupConfigAppAsync()

    // const cookie = new Cookies()
    // const cookies = cookie.get("user-mutui-history")

    // let gaClientID = cookie.get("_ga")
    // if (gaClientID) {
    // 	gaClientID = gaClientID.slice(6)
    // 	store.dispatch(CHAT_MUTUO_SET_MESSAGES_CLIENT_ID(gaClientID))
    // }
    // const chatUID = cookie.get("chatmutuo-uid")
    // if (chatUID) {
    // 	store.dispatch(CHAT_MUTUO_SET_MESSAGES_UID(chatUID))
    // }
    // if (chatUID || gaClientID) {
    // 	store.dispatch(
    // 		CHAT_MUTUO_FETCH_HISTORY({
    // 			uid: chatUID,
    // 			clientId: gaClientID,
    // 		})
    // 	)
    // }

    const cookie = new Cookies();
    const savedMessage = cookie.get("latest-cms-message");
    store.dispatch(CHAT_MUTUO_IS_LAST_LINK_MESSAGES_VISIBILE(true));

    if (savedMessage !== undefined) {
      store.dispatch(CHAT_MUTUO_LATEST_CMS_MESSAGE(savedMessage));
    }

    store.dispatch(CHAT_MUTUO_IS_WIZARD_VISIBLE(abilita ? true : false));
    if (data.length > 0) {
      store.dispatch(CHAT_MUTUO_IS_ACTIVE_LAST_CMS_MESSAGE(true));
      store.dispatch(CHAT_MUTUO_IS_WIZARD_VISIBLE(false));
      store.dispatch(CHAT_MUTUO_HIDE_OLD_QUESTIONS());
      // store.dispatch(CHAT_MUTUO_IS_LAST_LINK_MESSAGES_VISIBILE(true));
      const lastMessage = data[data.length - 1];
      if (
        !savedMessage &&
        lastMessage.Sender === "cms" &&
        lastMessage.Data?.elementi
      ) {
        store.dispatch(
          CHAT_MUTUO_LATEST_CMS_MESSAGE(lastMessage.Data.elementi)
        );
        cookie.set("latest-cms-message", lastMessage.Data.elementi, {
          path: "/",
          expires: new Date(Date.now() + 86400000), // 1 día
        });
      }
    }
  }, []);
  return <>{children}</>;
}

export const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      <InitialSetupConfigApp>{element}</InitialSetupConfigApp>
    </Provider>
  );
};

export const wrapPageElement = ({ element, props }) => {
  if (element?.key?.includes("404.html")) {
    return element;
  }
  const {
    pageContext: { isWidget = false },
  } = props;
  if (isWidget) {
    return <main className="__iframe">{element}</main>;
  }
  return <Layout {...props}>{element}</Layout>;
};

export const replaceHydrateFunction = () => {
  return (element, container) => {
    createRoot(container).render(element);
  };
};

// export const shouldUpdateScroll = ({
// 	routerProps: { location },
// 	getSavedScrollPosition,
// }) => {
// 	const currentPosition = getSavedScrollPosition(location)
// 	setTimeout(() => {
// 		window.scrollTo(...(currentPosition || [0, 0]))
// 	}, 0)
// 	return false
// }

export const shouldUpdateScroll = ({
  routerProps: { location: currentLocation = "" },
  prevRouterProps,
  getSavedScrollPosition,
}) => {
  window.history.scrollRestoration = "manual";
  const currentPosition = getSavedScrollPosition(
    currentLocation,
    currentLocation.key
  );

  // FAKE MODAL (VERIFICA || MUTUO) === INSTANT SCROLL
  const { pathname: prevPathname = "" } = prevRouterProps?.location || {};
  // console.log('CURRENT --> ', currentLocation.pathname)
  // console.log('PREV --> ', prevPathname)
  const prevIsFakeModal = new RegExp(/\/verifica\/|\/mutuo\//);
  if (prevPathname.match(prevIsFakeModal)) {
    document.documentElement.style.scrollBehavior = "auto";
  }

  // GLOSSARIO
  const glossarioRegex = new RegExp(/^\/glossario-mutui\/$/);
  if (currentLocation.pathname.match(glossarioRegex)) {
    return false;
  }
  // HOMEPAGE
  const homepageRegex = new RegExp(/^\/$/);
  if (currentLocation.pathname.match(homepageRegex)) {
    window.scrollTo(0, 0);
    return false;
  }

  // console.log("currentPosition> ", currentPosition);

  if (!currentPosition) {
    // console.log("SCROLL TO TOP - no saved position");
    window.scrollTo(0, 0);
    return false;
  }

  const [x, y] = currentPosition;

  // Se la posizione è [0, 0] e siamo già in alto, non fare nulla
  if (x === 0 && y === 0) {
    setTimeout(() => {
      requestAnimationFrame(() => {
        if (window.scrollY > 0) {
          window.scrollTo(0, 0);
        }
      });
    }, 100);
    return false;
  }

  // Scroll alla posizione salvata
  setTimeout(() => {
    requestAnimationFrame(() => {
      // console.log("SCROLL TO SAVED POSITION");
      window.scrollTo(x, y);
    });
  }, 100);
};
